import { render } from "./ProvinceTaskTable.vue?vue&type=template&id=4f6506ac&scoped=true&ts=true"
import script from "./ProvinceTaskTable.ts?vue&type=script&lang=ts"
export * from "./ProvinceTaskTable.ts?vue&type=script&lang=ts"

import "./ProvinceTaskTable.scss?vue&type=style&index=0&id=4f6506ac&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6506ac"]])

export default __exports__